var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAjutes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_20945",
    "data-name": "Group 20945",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.902,
    height: 55.633,
    viewBox: "0 0 51.902 55.633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7645",
    "data-name": "Path 7645",
    d: "M73.588,69.543a1.059,1.059,0,0,1,.73-.6l6.986-1.6-2.578-1.475-.137-.075L65.208,58.169,64.7,76.654l4.669-4.875a1.042,1.042,0,0,1,1.654.206l4.967,8.807,2.526-1.9L73.64,70.478a1.1,1.1,0,0,1-.052-.934Z",
    transform: "translate(-29.402 -25.159)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7646",
    "data-name": "Path 7646",
    d: "M57.914,16.865h2.079v-4.98A5.639,5.639,0,0,0,54.358,6.25H14.809a5.64,5.64,0,0,0-5.625,5.635v4.98ZM16.078,14.058a1.56,1.56,0,1,1,1.535-1.56A1.561,1.561,0,0,1,16.078,14.058Zm5.2,0a1.56,1.56,0,1,1,1.535-1.56A1.561,1.561,0,0,1,21.276,14.058Zm5.2,0a1.56,1.56,0,1,1,1.535-1.56A1.56,1.56,0,0,1,26.474,14.058Z",
    transform: "translate(-9.184 -6.25)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7647",
    "data-name": "Path 7647",
    d: "M57.914,51.5l2.079,1.185V26.214H9.184V58.7a5.638,5.638,0,0,0,5.625,5.625H42.434l.052-2.081.467-17.507a1.045,1.045,0,0,1,1.56-.874ZM16.255,30.779l2.787-.01a3.574,3.574,0,0,1,6.914.01H40.063a1.039,1.039,0,0,1,0,2.079H25.872a3.575,3.575,0,0,1-6.768-.02l-2.839.02a1.04,1.04,0,0,1-.01-2.079Zm.01,9.159H34.636a3.579,3.579,0,1,1,.072,2.079H16.265a1.039,1.039,0,0,1,0-2.079Zm24.983,11.03a1.027,1.027,0,0,1-.3.738,1.041,1.041,0,0,1-.735.3l-8.161-.02a3.571,3.571,0,0,1-6.415.01l-9.211.01a1.04,1.04,0,0,1,0-2.079l8.879-.01a3.578,3.578,0,0,1,7.081-.01l7.838.02a1.036,1.036,0,0,1,.733.3,1.022,1.022,0,0,1,.3.735Z",
    transform: "translate(-9.184 -13.521)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7648",
    "data-name": "Path 7648",
    d: "M29.288,35.467a1.5,1.5,0,1,0-1.475-1.5A1.5,1.5,0,0,0,29.288,35.467Z",
    transform: "translate(-15.968 -15.796)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7649",
    "data-name": "Path 7649",
    d: "M39.245,61.9A1.508,1.508,0,1,0,40.72,63.4,1.508,1.508,0,0,0,39.245,61.9Z",
    transform: "translate(-19.595 -26.516)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7650",
    "data-name": "Path 7650",
    d: "M53.815,49.873a1.5,1.5,0,1,0-1.475-1.5A1.5,1.5,0,0,0,53.815,49.873Z",
    transform: "translate(-24.901 -21.043)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAjutes);
export default __webpack_public_path__ + "static/media/icon_ajutes.fdf80cc048f518a5253ac7bdfd3502f0.svg";
export { ForwardRef as ReactComponent };